import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../store';
import { ItemType, MappingItemIdIndexType } from '../../../types';
import { ProjectTreeItemType } from '../projectsTreeTypes';

type ItemsRefType = {
    itemsList: ItemType[];
    mappingItemIdIndex: MappingItemIdIndexType;
    previousTreeItems: string | null;
};

export const useProjectTreeItems = () => {
    const itemsList = useSelector<RootState, ItemType[]>((state) => state.gantItems.itemsList);
    const mappingItemIdIndex = useSelector<RootState, MappingItemIdIndexType>((state) => state.gant.mappingItemIdIndex);
    const itemsRef = useRef<ItemsRefType>({
        itemsList,
        mappingItemIdIndex,
        previousTreeItems: null,
    });

    useEffect(() => {
        const projectTreeItems: ProjectTreeItemType[] = itemsList.map((item) => ({
            id: item.id,
            name: item.name,
            projectId: item.projectId,
            children: item.children,
            type: item.type,
            hideForCollapse: item.hideForCollapse,
            idIndex: item.idIndex,
            roleItem: item.roleItem,
            numberWBS: item.numberWBS,
            parentId: item.parentId,
        }));

        const projectTreeItemsStr = JSON.stringify(projectTreeItems);

        if (itemsRef.current.previousTreeItems !== projectTreeItemsStr) {
            itemsRef.current = {
                itemsList,
                mappingItemIdIndex,
                previousTreeItems: projectTreeItemsStr,
            };
        }
    }, [itemsList, mappingItemIdIndex]);

    return itemsRef.current;
};
